import React from 'react';
import SelectField from '@/forms/_fields_v2/SelectField';
import { getPathAfterSchoolYear } from '@/utils/schoolYearPath';
import useRouter from '@/hooks/useRouter';
import useNavigationLinks from '@/pages/dashboard/Sidebar/useNavigationLinks';

export default function SchoolYearSelectField() {
  const { location, history } = useRouter();

  const { schoolYearLinks, currentSchoolYearLink } = useNavigationLinks();

  return (
    <SelectField
      label="School year"
      value={currentSchoolYearLink?.href}
      placeholder={currentSchoolYearLink ? undefined : 'Unknown school year'}
      options={{
        data: schoolYearLinks.map(function(link) {
          return {
            id: link.href,
            data: {
              name: link.name
            }
          };
        })
      }}
      optionLabel="name"
      onChange={function(id) {
        if (!id) {
          return;
        }

        history.push(`${id}${getPathAfterSchoolYear(location.pathname, currentSchoolYearLink)}`);
      }}
    />
  );
}
